
  export const initialProjectState = {
  "brandingData": {
    "relationTo": "branding",
    "name": "Branding - Trillium",
    "colours": {
      "primary": "#DED7CD",
      "secondary": "#754248",
      "accent": "#cdaa78"
    },
    "fonts": {
      "primaryFont": {
        "id": "675046ea9acd836c8f7bff45",
        "publicURL": "/payload/projectFontMedia/QuicheSans-Regular.otf",
        "filename": "QuicheSans-Regular.otf",
        "mimeType": "font/otf",
        "filesize": 96240,
        "createdAt": "2024-12-04T12:11:22.827Z",
        "updatedAt": "2024-12-04T12:11:22.827Z",
        "url": "https://luna.vmistudio.com/api/projectFontMedia/file/QuicheSans-Regular.otf",
        "thumbnailURL": null
      },
      "secondaryFont": {
        "id": "678e540e3ac89aec3d0c69fa",
        "publicURL": "/payload/projectFontMedia/Baskervville-Italic-1.ttf",
        "filename": "Baskervville-Italic-1.ttf",
        "mimeType": "font/ttf",
        "filesize": 82364,
        "createdAt": "2025-01-20T13:47:58.918Z",
        "updatedAt": "2025-01-20T13:47:58.918Z",
        "url": "https://luna.vmistudio.com/api/projectFontMedia/file/Baskervville-Italic-1.ttf",
        "thumbnailURL": null
      }
    },
    "logos": {
      "lightColourLogo": {
        "id": "671b64066536c7a47560951b",
        "publicURL": "/payload/projectLogoMedia/TriliumLogoLight.png",
        "filename": "TriliumLogoLight.png",
        "mimeType": "image/png",
        "filesize": 6081,
        "width": 600,
        "height": 320,
        "focalX": 50,
        "focalY": 50,
        "createdAt": "2024-10-25T09:25:26.159Z",
        "updatedAt": "2024-10-25T09:25:26.159Z",
        "url": "https://luna.vmistudio.com/api/projectLogoMedia/file/TriliumLogoLight.png",
        "thumbnailURL": null
      },
      "darkColourLogo": {
        "id": "671b640e6536c7a47560953f",
        "publicURL": "/payload/projectLogoMedia/TriliumLogoDark.png",
        "filename": "TriliumLogoDark.png",
        "mimeType": "image/png",
        "filesize": 2308,
        "width": 189,
        "height": 100,
        "focalX": 50,
        "focalY": 50,
        "createdAt": "2024-10-25T09:25:34.611Z",
        "updatedAt": "2024-10-25T09:25:34.611Z",
        "url": "https://luna.vmistudio.com/api/projectLogoMedia/file/TriliumLogoDark.png",
        "thumbnailURL": null
      }
    },
    "bgImage": {
      "id": "671bb11fee5ee5f3d8e8988e",
      "publicURL": "/payload/splashMedia/TriliumBg.jpg",
      "filename": "TriliumBg.jpg",
      "mimeType": "image/jpeg",
      "filesize": 7717101,
      "width": 7680,
      "height": 4320,
      "focalX": 50,
      "focalY": 50,
      "createdAt": "2024-10-25T14:54:23.584Z",
      "updatedAt": "2024-10-25T14:54:23.584Z",
      "url": "https://luna.vmistudio.com/api/splashMedia/file/TriliumBg.jpg",
      "thumbnailURL": null
    }
  },
  "navigationData": {
    "relationTo": "navigation",
    "name": "Navigation - Trillium",
    "menuItems": [
      {
        "include": "true",
        "navLabel": "Trillium",
        "pageType": "orbits",
        "id": "671b63238844e00026fe8c2a"
      },
      {
        "include": "true",
        "navLabel": "Floorplans",
        "pageType": "residences",
        "id": "671b63238844e00026fe8c24"
      },
      {
        "include": "true",
        "navLabel": "Amenities",
        "pageType": "info1",
        "id": "671b63238844e00026fe8c2d"
      },
      {
        "include": "true",
        "navLabel": "Local Area",
        "pageType": "map",
        "id": "671b63238844e00026fe8c25"
      },
      {
        "include": "true",
        "navLabel": "Gallery",
        "pageType": "gallery",
        "id": "671b63238844e00026fe8c26"
      },
      {
        "include": "true",
        "navLabel": "Favourites",
        "pageType": "favourites",
        "id": "671b63238844e00026fe8c27"
      },
      {
        "include": "false",
        "navLabel": "Explorer",
        "pageType": "explorer",
        "id": "671b63238844e00026fe8c28"
      },
      {
        "include": "false",
        "navLabel": "Shared Ownership",
        "pageType": "sharedOwnership",
        "id": "671b63238844e00026fe8c2b"
      },
      {
        "include": "false",
        "navLabel": "About Page",
        "pageType": "about",
        "id": "671b63238844e00026fe8c2c"
      },
      {
        "include": "true",
        "navLabel": "Media",
        "pageType": "development",
        "id": "671b63238844e00026fe8c29"
      }
    ],
    "layout": "sidebar",
    "logo": "darkColourLogo",
    "logoWidth": 16,
    "fontColour": "secondary",
    "bgColor": "secondary",
    "burgerBackgroundColour": "secondary",
    "burgerBorderColour": "accent",
    "burgerWidth": 3.5,
    "shapeColour": "secondary"
  },
  "explorerData": null,
  "sharedOwnershipData": {
    "relationTo": "sharedOwnership",
    "name": "Shared Ownership - Trillium",
    "feature": "sharedOwnership"
  },
  "aboutData": {
    "relationTo": "about",
    "name": "About - Trillium",
    "feature": "about",
    "sections": []
  },
  "info1Data": {
    "relationTo": "info1",
    "name": "Info1 - Trillium",
    "feature": "info1",
    "style": "full",
    "sections": [
      {
        "title": "Amenities",
        "block": [
          {
            "headline": "The Spa",
            "body": "Trillium offers exquisite amenities designed for relaxation and recreation, including a private swimming pool, hydro pool, wellness suite, private dining room, co-working facility and expansive landscaped\nopen spaces. Counter the fast pace of the city with moments of clarity and calm. Unwind in the infrared sauna, cool down in the plunge pool or take a peaceful swim in the 20-meter-long pool. These facilities will be open from the first completions of The Burton*.",
            "img": {
              "id": "6790fb2e3ac89aec3d0cf2a5",
              "publicURL": "/payload/galleryMedia/amenitiesPlate-3.png",
              "filename": "amenitiesPlate-3.png",
              "mimeType": "image/png",
              "filesize": 404808,
              "width": 1583,
              "height": 1132,
              "focalX": 50,
              "focalY": 50,
              "createdAt": "2025-01-22T14:05:34.831Z",
              "updatedAt": "2025-01-22T14:05:34.831Z",
              "url": "https://luna.vmistudio.com/api/galleryMedia/file/amenitiesPlate-3.png",
              "thumbnailURL": null
            },
            "id": "671b6d328844e00026fe996e"
          },
          {
            "headline": "First Floor Facilities ",
            "img": {
              "id": "6793ba3f3ac89aec3d0d64d8",
              "publicURL": "/payload/galleryMedia/firstFloor-1.jpg",
              "filename": "firstFloor-1.jpg",
              "mimeType": "image/jpeg",
              "filesize": 1472788,
              "width": 4374,
              "height": 4534,
              "focalX": 50,
              "focalY": 50,
              "createdAt": "2025-01-24T16:05:19.322Z",
              "updatedAt": "2025-01-24T16:05:19.322Z",
              "url": "https://luna.vmistudio.com/api/galleryMedia/file/firstFloor-1.jpg",
              "thumbnailURL": null
            },
            "id": "67937769f4294f909c4df855"
          },
          {
            "headline": "Invigorating Hydro Pool",
            "body": "Residents can enjoy exclusive access to a complete wellness suite, including a 20-meter-long pool, hydrotherapy and wellness spaces.\n",
            "img": {
              "id": "678f8c873ac89aec3d0cb099",
              "publicURL": "/payload/galleryMedia/386_PGPS_HYDROPOOL-3.webp",
              "filename": "386_PGPS_HYDROPOOL-3.webp",
              "mimeType": "image/webp",
              "filesize": 400464,
              "width": 2250,
              "height": 1500,
              "focalX": 50,
              "focalY": 50,
              "createdAt": "2025-01-21T12:01:11.885Z",
              "updatedAt": "2025-01-21T12:01:11.885Z",
              "url": "https://luna.vmistudio.com/api/galleryMedia/file/386_PGPS_HYDROPOOL-3.webp",
              "thumbnailURL": null
            },
            "id": "671b6be08844e00026fe98fe"
          },
          {
            "headline": "Exclusive Gym Access",
            "body": "Host a sophisticated gathering in Trillium’s private dining room. For that special occasion, significant celebration or romantic adventure Trillium’s private dining space awaits your arrival. Equipped with everything required for an unforgettable gathering, this exclusive space is effortless to book through your concierge.",
            "img": {
              "id": "678fb7733ac89aec3d0cce9e",
              "publicURL": "/payload/galleryMedia/vb1706432_weg2034_3200x2133-CMYK.webp",
              "filename": "vb1706432_weg2034_3200x2133-CMYK.webp",
              "mimeType": "image/webp",
              "filesize": 192126,
              "width": 1920,
              "height": 1280,
              "focalX": 50,
              "focalY": 50,
              "createdAt": "2025-01-21T15:04:19.719Z",
              "updatedAt": "2025-01-21T15:04:19.719Z",
              "url": "https://luna.vmistudio.com/api/galleryMedia/file/vb1706432_weg2034_3200x2133-CMYK.webp",
              "thumbnailURL": null
            },
            "id": "671b6d488844e00026fe996f"
          },
          {
            "headline": "Private co-working Spaces",
            "body": "Trillium’s communal and private co-working spaces offer the perfect place in which to come together with friends, family and colleagues.",
            "img": {
              "id": "678f8ca13ac89aec3d0cb105",
              "publicURL": "/payload/galleryMedia/386_PGPS_COWORKING-1.webp",
              "filename": "386_PGPS_COWORKING-1.webp",
              "mimeType": "image/webp",
              "filesize": 359502,
              "width": 2399,
              "height": 1500,
              "focalX": 50,
              "focalY": 50,
              "createdAt": "2025-01-21T12:01:37.634Z",
              "updatedAt": "2025-01-21T12:01:37.634Z",
              "url": "https://luna.vmistudio.com/api/galleryMedia/file/386_PGPS_COWORKING-1.webp",
              "thumbnailURL": null
            },
            "id": "677fb1ea17d8ced98bf1bfd5"
          },
          {
            "headline": "Exclusive Private Dining",
            "body": "For that special occasion or significant celebration, Trillium’s private dining\nis bespoke to you.",
            "img": {
              "id": "678f8cac3ac89aec3d0cb11d",
              "publicURL": "/payload/galleryMedia/386_PGPS_DINING-1.webp",
              "filename": "386_PGPS_DINING-1.webp",
              "mimeType": "image/webp",
              "filesize": 199520,
              "width": 2500,
              "height": 1500,
              "focalX": 50,
              "focalY": 50,
              "createdAt": "2025-01-21T12:01:48.149Z",
              "updatedAt": "2025-01-21T12:01:48.149Z",
              "url": "https://luna.vmistudio.com/api/galleryMedia/file/386_PGPS_DINING-1.webp",
              "thumbnailURL": null
            },
            "id": "677fb22517d8ced98bf1bfd6"
          },
          {
            "headline": "Relaxing Spa Lounge",
            "img": {
              "id": "678f8cbd3ac89aec3d0cb16e",
              "publicURL": "/payload/galleryMedia/386_PGPS_SPA_LOUNGE-3.webp",
              "filename": "386_PGPS_SPA_LOUNGE-3.webp",
              "mimeType": "image/webp",
              "filesize": 321328,
              "width": 2250,
              "height": 1500,
              "focalX": 50,
              "focalY": 50,
              "createdAt": "2025-01-21T12:02:05.677Z",
              "updatedAt": "2025-01-21T12:02:05.677Z",
              "url": "https://luna.vmistudio.com/api/galleryMedia/file/386_PGPS_SPA_LOUNGE-3.webp",
              "thumbnailURL": null
            },
            "id": "677fb92917d8ced98bf1bfd8"
          },
          {
            "headline": "Serene Pool & Sauna",
            "img": {
              "id": "678f8ed13ac89aec3d0cbc4b",
              "publicURL": "/payload/galleryMedia/386_PGPS_POOL-2.webp",
              "filename": "386_PGPS_POOL-2.webp",
              "mimeType": "image/webp",
              "filesize": 229122,
              "width": 2500,
              "height": 1407,
              "focalX": 50,
              "focalY": 50,
              "createdAt": "2025-01-21T12:10:57.895Z",
              "updatedAt": "2025-01-21T12:10:57.895Z",
              "url": "https://luna.vmistudio.com/api/galleryMedia/file/386_PGPS_POOL-2.webp",
              "thumbnailURL": null
            },
            "id": "678fae26cb76289b59b13069"
          }
        ],
        "id": "671b6bca8844e00026fe98fd"
      }
    ]
  },
  "theLocationData": null,
  "developmentData": {
    "relationTo": "development",
    "name": "Development - Trillium",
    "feature": "development",
    "pdfFile": {
      "id": "678f7a2b3ac89aec3d0ca5ca",
      "publicURL": "/payload/galleryMedia/pgps-brochure.pdf",
      "filename": "pgps-brochure.pdf",
      "mimeType": "application/pdf",
      "filesize": 9395483,
      "createdAt": "2025-01-21T10:42:51.160Z",
      "updatedAt": "2025-01-21T10:42:51.160Z",
      "url": "https://luna.vmistudio.com/api/galleryMedia/file/pgps-brochure.pdf",
      "thumbnailURL": null
    }
  },
  "favouritesData": {
    "relationTo": "favourites",
    "name": "Favourites - Trillium",
    "feature": "favourites",
    "shareType": {
      "shareAppURL": "https://trillium-pwa.vercel.app",
      "hiddenProjectId": {
        "id": "671b63236536c7a47560930f",
        "name": "Trillium",
        "organisation": "671b628b6536c7a47560927b",
        "published": true,
        "createdAt": "2024-10-25T09:21:39.017Z",
        "updatedAt": "2024-10-25T10:36:52.415Z",
        "pages": [
          {
            "relationTo": "branding",
            "value": "671b63236536c7a47560931f"
          },
          {
            "relationTo": "navigation",
            "value": "671b63236536c7a475609320"
          },
          {
            "relationTo": "splash",
            "value": "671b63236536c7a47560931b"
          },
          {
            "relationTo": "residences",
            "value": "671b63236536c7a47560931c"
          },
          {
            "relationTo": "map",
            "value": "671b63236536c7a475609321"
          },
          {
            "relationTo": "gallery",
            "value": "671b63236536c7a47560931d"
          },
          {
            "relationTo": "favourites",
            "value": "671b63236536c7a47560931e"
          },
          {
            "relationTo": "orbits",
            "value": "671b63236536c7a475609311"
          },
          {
            "relationTo": "explorer",
            "value": "671b63236536c7a475609312"
          },
          {
            "relationTo": "development",
            "value": "671b63236536c7a475609313"
          },
          {
            "relationTo": "sharedOwnership",
            "value": "671b63236536c7a475609314"
          },
          {
            "relationTo": "about",
            "value": "671b63236536c7a475609315"
          },
          {
            "relationTo": "info1",
            "value": "671b63236536c7a475609316"
          },
          {
            "relationTo": "unitTypes",
            "value": "671b63236536c7a475609318"
          },
          {
            "relationTo": "unitViews",
            "value": "671b63236536c7a475609319"
          },
          {
            "relationTo": "unitDetails",
            "value": "671b63236536c7a47560931a"
          },
          {
            "relationTo": "unitAvailability",
            "value": "671b711d6d6a38093a3ff3a3"
          }
        ],
        "deployHook": "https://api.vercel.com/v1/integrations/deploy/prj_jloQ0Kqx7gQnvBFLG5hau9dtQy9T/cGzHAE3MOh"
      },
      "options": "qrCodeOnly"
    },
    "emailSettings": {
      "ccAgentList": []
    }
  },
  "galleryData": {
    "relationTo": "gallery",
    "name": "Gallery - Trillium",
    "feature": "masonrygallery",
    "scroll": "horizontal",
    "enableCategories": true,
    "enableRounded": false,
    "style": "full",
    "spacing": "small",
    "categoryStyle": "type2",
    "categoryColor": "black",
    "images": [
      {
        "content": {
          "id": "676002ce3ac89aec3d0bded2",
          "publicURL": "/payload/galleryMedia/36_PGPS_LIVING_ROOM.webp",
          "filename": "36_PGPS_LIVING_ROOM.webp",
          "mimeType": "image/webp",
          "filesize": 261458,
          "width": 2500,
          "height": 1250,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-12-16T10:37:02.041Z",
          "updatedAt": "2025-01-21T11:59:47.976Z",
          "thumbnailURL": null,
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/36_PGPS_LIVING_ROOM.webp"
        },
        "category": "Homes",
        "id": "671b685c8844e00026fe95b6"
      },
      {
        "content": {
          "id": "678f8c7a3ac89aec3d0cb068",
          "publicURL": "/payload/galleryMedia/386_PGPS_HALLWAY.webp",
          "filename": "386_PGPS_HALLWAY.webp",
          "mimeType": "image/webp",
          "filesize": 79598,
          "width": 1125,
          "height": 1500,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-21T12:00:58.828Z",
          "updatedAt": "2025-01-21T12:00:58.828Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/386_PGPS_HALLWAY.webp",
          "thumbnailURL": null
        },
        "category": "Homes",
        "id": "6760040066c72f8343d7f53c"
      },
      {
        "content": {
          "id": "678f8cd93ac89aec3d0cb1d2",
          "publicURL": "/payload/galleryMedia/386_PGPS_BATHROOM_ENSUITE.webp",
          "filename": "386_PGPS_BATHROOM_ENSUITE.webp",
          "mimeType": "image/webp",
          "filesize": 339536,
          "width": 1536,
          "height": 1500,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-21T12:02:33.837Z",
          "updatedAt": "2025-01-21T12:02:33.837Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/386_PGPS_BATHROOM_ENSUITE.webp",
          "thumbnailURL": null
        },
        "category": "Homes",
        "id": "6760042566c72f8343d7f53d"
      },
      {
        "content": {
          "id": "678f8d203ac89aec3d0cb4b9",
          "publicURL": "/payload/galleryMedia/386_PGPS_BATHROOM-2.webp",
          "filename": "386_PGPS_BATHROOM-2.webp",
          "mimeType": "image/webp",
          "filesize": 305452,
          "width": 1585,
          "height": 1500,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-21T12:03:44.928Z",
          "updatedAt": "2025-01-21T12:03:44.928Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/386_PGPS_BATHROOM-2.webp",
          "thumbnailURL": null
        },
        "category": "Homes",
        "id": "6760043666c72f8343d7f53e"
      },
      {
        "content": {
          "id": "678f8d543ac89aec3d0cb51d",
          "publicURL": "/payload/galleryMedia/386_PGPS_COWORKING-2.webp",
          "filename": "386_PGPS_COWORKING-2.webp",
          "mimeType": "image/webp",
          "filesize": 359502,
          "width": 2399,
          "height": 1500,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-21T12:04:36.520Z",
          "updatedAt": "2025-01-21T12:04:36.520Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/386_PGPS_COWORKING-2.webp",
          "thumbnailURL": null
        },
        "category": "Amenities",
        "id": "6760043d66c72f8343d7f53f"
      },
      {
        "content": {
          "id": "678f8d633ac89aec3d0cb532",
          "publicURL": "/payload/galleryMedia/386_PGPS_CONCIERGE.webp",
          "filename": "386_PGPS_CONCIERGE.webp",
          "mimeType": "image/webp",
          "filesize": 391846,
          "width": 2500,
          "height": 1407,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-21T12:04:51.297Z",
          "updatedAt": "2025-01-21T12:04:51.297Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/386_PGPS_CONCIERGE.webp",
          "thumbnailURL": null
        },
        "category": "Amenities",
        "id": "6760045c66c72f8343d7f540"
      },
      {
        "content": {
          "id": "678f8d9a3ac89aec3d0cb5c6",
          "publicURL": "/payload/galleryMedia/PGPS_BEDROOM_DUSK.webp",
          "filename": "PGPS_BEDROOM_DUSK.webp",
          "mimeType": "image/webp",
          "filesize": 90350,
          "width": 1451,
          "height": 1500,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-21T12:05:46.822Z",
          "updatedAt": "2025-01-21T12:05:46.822Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/PGPS_BEDROOM_DUSK.webp",
          "thumbnailURL": null
        },
        "category": "Homes",
        "id": "6760049c66c72f8343d7f542"
      },
      {
        "content": {
          "id": "678f8db23ac89aec3d0cb628",
          "publicURL": "/payload/galleryMedia/386_PGPS_BEDROOM.webp",
          "filename": "386_PGPS_BEDROOM.webp",
          "mimeType": "image/webp",
          "filesize": 165364,
          "width": 1451,
          "height": 1500,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-21T12:06:10.972Z",
          "updatedAt": "2025-01-21T12:06:10.972Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/386_PGPS_BEDROOM.webp",
          "thumbnailURL": null
        },
        "category": "Homes",
        "id": "676004d666c72f8343d7f543"
      },
      {
        "content": {
          "id": "678f8dc23ac89aec3d0cb732",
          "publicURL": "/payload/galleryMedia/386_PGPS_BALCONY.webp",
          "filename": "386_PGPS_BALCONY.webp",
          "mimeType": "image/webp",
          "filesize": 541888,
          "width": 2500,
          "height": 1429,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-21T12:06:26.353Z",
          "updatedAt": "2025-01-21T12:06:26.353Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/386_PGPS_BALCONY.webp",
          "thumbnailURL": null
        },
        "category": "Homes",
        "id": "676004e366c72f8343d7f544"
      },
      {
        "content": {
          "id": "678f8ddc3ac89aec3d0cb99d",
          "publicURL": "/payload/galleryMedia/386_PGPS_EDGEWARE_ROAD_DUSK-1.webp",
          "filename": "386_PGPS_EDGEWARE_ROAD_DUSK-1.webp",
          "mimeType": "image/webp",
          "filesize": 733730,
          "width": 2250,
          "height": 1500,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-21T12:06:52.990Z",
          "updatedAt": "2025-01-21T12:06:52.990Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/386_PGPS_EDGEWARE_ROAD_DUSK-1.webp",
          "thumbnailURL": null
        },
        "category": "Exteriors",
        "id": "676004f366c72f8343d7f545"
      },
      {
        "content": {
          "id": "678f8ded3ac89aec3d0cb9dc",
          "publicURL": "/payload/galleryMedia/386_PGPS_EDGWARE_ROAD.webp",
          "filename": "386_PGPS_EDGWARE_ROAD.webp",
          "mimeType": "image/webp",
          "filesize": 710910,
          "width": 2250,
          "height": 1500,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-21T12:07:09.100Z",
          "updatedAt": "2025-01-21T12:07:09.100Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/386_PGPS_EDGWARE_ROAD.webp",
          "thumbnailURL": null
        },
        "category": "Exteriors",
        "id": "6760050166c72f8343d7f546"
      },
      {
        "content": {
          "id": "678f8dfe3ac89aec3d0cba14",
          "publicURL": "/payload/galleryMedia/386_PGPS_GREEN_VEIN-2.webp",
          "filename": "386_PGPS_GREEN_VEIN-2.webp",
          "mimeType": "image/webp",
          "filesize": 809944,
          "width": 2250,
          "height": 1500,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-21T12:07:26.945Z",
          "updatedAt": "2025-01-21T12:07:26.945Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/386_PGPS_GREEN_VEIN-2.webp",
          "thumbnailURL": null
        },
        "category": "Exteriors",
        "id": "6760053b66c72f8343d7f547"
      },
      {
        "content": {
          "id": "678f8e2f3ac89aec3d0cba9a",
          "publicURL": "/payload/galleryMedia/386_PGPS_HUMMINGBIRD_LANDMARK-1.webp",
          "filename": "386_PGPS_HUMMINGBIRD_LANDMARK-1.webp",
          "mimeType": "image/webp",
          "filesize": 245124,
          "width": 2500,
          "height": 1407,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-21T12:08:15.600Z",
          "updatedAt": "2025-01-21T12:08:15.600Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/386_PGPS_HUMMINGBIRD_LANDMARK-1.webp",
          "thumbnailURL": null
        },
        "category": "Exteriors",
        "id": "678eb0d4dbc223214fd5efad"
      },
      {
        "content": {
          "id": "678f8e123ac89aec3d0cba4b",
          "publicURL": "/payload/galleryMedia/386_PGPS_HERO-1.webp",
          "filename": "386_PGPS_HERO-1.webp",
          "mimeType": "image/webp",
          "filesize": 272232,
          "width": 1500,
          "height": 1500,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-21T12:07:46.044Z",
          "updatedAt": "2025-01-21T12:07:46.044Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/386_PGPS_HERO-1.webp",
          "thumbnailURL": null
        },
        "category": "Exteriors",
        "id": "6760054466c72f8343d7f548"
      },
      {
        "content": {
          "id": "678eae783ac89aec3d0c8937",
          "publicURL": "/payload/galleryMedia/AdobeStock_516373933.webp",
          "filename": "AdobeStock_516373933.webp",
          "mimeType": "image/webp",
          "filesize": 854722,
          "width": 1980,
          "height": 1320,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-20T20:13:44.705Z",
          "updatedAt": "2025-01-20T20:13:44.705Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/AdobeStock_516373933.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "678eae62dbc223214fd5ef9f"
      },
      {
        "content": {
          "id": "678fa1233ac89aec3d0cc6b5",
          "publicURL": "/payload/galleryMedia/Copy of 25930_IMG_7611-EDIT.jpg",
          "filename": "Copy of 25930_IMG_7611-EDIT.jpg",
          "mimeType": "image/jpeg",
          "filesize": 450208,
          "width": 819,
          "height": 1459,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-21T13:29:07.783Z",
          "updatedAt": "2025-01-21T13:29:07.783Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/Copy of 25930_IMG_7611-EDIT.jpg",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "678eae86dbc223214fd5efa0"
      },
      {
        "content": {
          "id": "678eaee63ac89aec3d0c8999",
          "publicURL": "/payload/galleryMedia/Copy of E448_model_08-EDIT.webp",
          "filename": "Copy of E448_model_08-EDIT.webp",
          "mimeType": "image/webp",
          "filesize": 460412,
          "width": 1965,
          "height": 2944,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-20T20:15:34.234Z",
          "updatedAt": "2025-01-20T20:15:34.234Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/Copy of E448_model_08-EDIT.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "678eaed8dbc223214fd5efa2"
      },
      {
        "content": {
          "id": "678eaf043ac89aec3d0c89dd",
          "publicURL": "/payload/galleryMedia/Copy of PHM_WEG_0236-WARM-EDIT.webp",
          "filename": "Copy of PHM_WEG_0236-WARM-EDIT.webp",
          "mimeType": "image/webp",
          "filesize": 381746,
          "width": 1800,
          "height": 1200,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-20T20:16:04.594Z",
          "updatedAt": "2025-01-20T20:16:04.594Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/Copy of PHM_WEG_0236-WARM-EDIT.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "678eaef6dbc223214fd5efa4"
      },
      {
        "content": {
          "id": "678eaf153ac89aec3d0c89f9",
          "publicURL": "/payload/galleryMedia/Copy of PHM_WEG_0238-WARM-EDIT-CMYK.webp",
          "filename": "Copy of PHM_WEG_0238-WARM-EDIT-CMYK.webp",
          "mimeType": "image/webp",
          "filesize": 316296,
          "width": 1200,
          "height": 1800,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-20T20:16:21.126Z",
          "updatedAt": "2025-01-20T20:16:21.126Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/Copy of PHM_WEG_0238-WARM-EDIT-CMYK.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "678eaf07dbc223214fd5efa5"
      },
      {
        "content": {
          "id": "678eaf2a3ac89aec3d0c8a16",
          "publicURL": "/payload/galleryMedia/Screenshot 2025-01-29 at 09.54.30.webp",
          "filename": "Screenshot 2025-01-29 at 09.54.30.webp",
          "mimeType": "image/webp",
          "filesize": 134166,
          "width": 1920,
          "height": 1281,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-20T20:16:42.879Z",
          "updatedAt": "2025-01-29T09:55:05.451Z",
          "thumbnailURL": null,
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/Screenshot 2025-01-29 at 09.54.30.webp"
        },
        "category": "Lifestyle",
        "id": "678eaf1edbc223214fd5efa6"
      },
      {
        "content": {
          "id": "678eaf393ac89aec3d0c8a32",
          "publicURL": "/payload/galleryMedia/Copy of weg_0139-WARM-EDIT.webp",
          "filename": "Copy of weg_0139-WARM-EDIT.webp",
          "mimeType": "image/webp",
          "filesize": 933092,
          "width": 2867,
          "height": 2057,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-20T20:16:57.772Z",
          "updatedAt": "2025-01-20T20:16:57.772Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/Copy of weg_0139-WARM-EDIT.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "678eaf2fdbc223214fd5efa7"
      },
      {
        "content": {
          "id": "678eaf493ac89aec3d0c8a4e",
          "publicURL": "/payload/galleryMedia/Copy of weg_0142-WARM-EDIT.webp",
          "filename": "Copy of weg_0142-WARM-EDIT.webp",
          "mimeType": "image/webp",
          "filesize": 366980,
          "width": 3302,
          "height": 2202,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-20T20:17:13.608Z",
          "updatedAt": "2025-01-20T20:17:13.608Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/Copy of weg_0142-WARM-EDIT.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "678eaf3bdbc223214fd5efa8"
      },
      {
        "content": {
          "id": "678eaf6f3ac89aec3d0c8afc",
          "publicURL": "/payload/galleryMedia/Copy of weg_0190-WARM-EDIT.webp",
          "filename": "Copy of weg_0190-WARM-EDIT.webp",
          "mimeType": "image/webp",
          "filesize": 730666,
          "width": 3222,
          "height": 1959,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-20T20:17:51.529Z",
          "updatedAt": "2025-01-20T20:17:51.529Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/Copy of weg_0190-WARM-EDIT.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "678eaf60dbc223214fd5efa9"
      },
      {
        "content": {
          "id": "678eaf8b3ac89aec3d0c8baa",
          "publicURL": "/payload/galleryMedia/Copy of www.andrewhendry.com94-WARM-EDIT.webp",
          "filename": "Copy of www.andrewhendry.com94-WARM-EDIT.webp",
          "mimeType": "image/webp",
          "filesize": 985610,
          "width": 2317,
          "height": 3475,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-20T20:18:19.278Z",
          "updatedAt": "2025-01-20T20:18:19.278Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/Copy of www.andrewhendry.com94-WARM-EDIT.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "678eaf7adbc223214fd5efaa"
      },
      {
        "content": {
          "id": "678eafa23ac89aec3d0c8bc6",
          "publicURL": "/payload/galleryMedia/Copy of www.andrewhendry.com404-CMYK.webp",
          "filename": "Copy of www.andrewhendry.com404-CMYK.webp",
          "mimeType": "image/webp",
          "filesize": 2019814,
          "width": 3475,
          "height": 2317,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-20T20:18:42.728Z",
          "updatedAt": "2025-01-20T20:18:42.728Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/Copy of www.andrewhendry.com404-CMYK.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "678eaf8edbc223214fd5efab"
      },
      {
        "content": {
          "id": "678eafb23ac89aec3d0c8be2",
          "publicURL": "/payload/galleryMedia/iStock-1857979915.webp",
          "filename": "iStock-1857979915.webp",
          "mimeType": "image/webp",
          "filesize": 103038,
          "width": 2164,
          "height": 1443,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-20T20:18:58.728Z",
          "updatedAt": "2025-01-20T20:18:58.728Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/iStock-1857979915.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "678eafa5dbc223214fd5efac"
      },
      {
        "content": {
          "id": "678f8e3c3ac89aec3d0cbab0",
          "publicURL": "/payload/galleryMedia/386_PGPS_HUMMINGBIRD_PADDINTON_GREEN-1.webp",
          "filename": "386_PGPS_HUMMINGBIRD_PADDINTON_GREEN-1.webp",
          "mimeType": "image/webp",
          "filesize": 404670,
          "width": 2500,
          "height": 1471,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-21T12:08:28.652Z",
          "updatedAt": "2025-01-21T12:08:28.652Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/386_PGPS_HUMMINGBIRD_PADDINTON_GREEN-1.webp",
          "thumbnailURL": null
        },
        "category": "Exteriors",
        "id": "678eb0eedbc223214fd5efae"
      },
      {
        "content": {
          "id": "678f8e483ac89aec3d0cbac5",
          "publicURL": "/payload/galleryMedia/386_PGPS_LIVING_ROOM_DUSK.webp",
          "filename": "386_PGPS_LIVING_ROOM_DUSK.webp",
          "mimeType": "image/webp",
          "filesize": 217824,
          "width": 2500,
          "height": 1250,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-21T12:08:40.379Z",
          "updatedAt": "2025-01-21T12:08:40.379Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/386_PGPS_LIVING_ROOM_DUSK.webp",
          "thumbnailURL": null
        },
        "category": "Homes",
        "id": "678eb103dbc223214fd5efaf"
      },
      {
        "content": {
          "id": "678f8e6e3ac89aec3d0cbb6a",
          "publicURL": "/payload/galleryMedia/PGPS_HALLWAY_DUSK.webp",
          "filename": "PGPS_HALLWAY_DUSK.webp",
          "mimeType": "image/webp",
          "filesize": 51434,
          "width": 1125,
          "height": 1500,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-21T12:09:18.214Z",
          "updatedAt": "2025-01-21T12:09:18.214Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/PGPS_HALLWAY_DUSK.webp",
          "thumbnailURL": null
        },
        "category": "Homes",
        "id": "678eb121dbc223214fd5efb1"
      },
      {
        "content": {
          "id": "678f8eb03ac89aec3d0cbbd8",
          "publicURL": "/payload/galleryMedia/386_PGPS_DINING-2.webp",
          "filename": "386_PGPS_DINING-2.webp",
          "mimeType": "image/webp",
          "filesize": 199520,
          "width": 2500,
          "height": 1500,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-21T12:10:24.280Z",
          "updatedAt": "2025-01-21T12:10:24.280Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/386_PGPS_DINING-2.webp",
          "thumbnailURL": null
        },
        "category": "Amenities",
        "id": "678f8ea06a9783f921c47488"
      },
      {
        "content": {
          "id": "678f8eba3ac89aec3d0cbbfe",
          "publicURL": "/payload/galleryMedia/386_PGPS_HYDROPOOL-4.webp",
          "filename": "386_PGPS_HYDROPOOL-4.webp",
          "mimeType": "image/webp",
          "filesize": 400464,
          "width": 2250,
          "height": 1500,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-21T12:10:34.332Z",
          "updatedAt": "2025-01-21T12:10:34.332Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/386_PGPS_HYDROPOOL-4.webp",
          "thumbnailURL": null
        },
        "category": "Amenities",
        "id": "678f8eb26a9783f921c47489"
      },
      {
        "content": {
          "id": "678f8ed13ac89aec3d0cbc4b",
          "publicURL": "/payload/galleryMedia/386_PGPS_POOL-2.webp",
          "filename": "386_PGPS_POOL-2.webp",
          "mimeType": "image/webp",
          "filesize": 229122,
          "width": 2500,
          "height": 1407,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-21T12:10:57.895Z",
          "updatedAt": "2025-01-21T12:10:57.895Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/386_PGPS_POOL-2.webp",
          "thumbnailURL": null
        },
        "category": "Amenities",
        "id": "678f8ec56a9783f921c4748a"
      },
      {
        "content": {
          "id": "678f8ee23ac89aec3d0cbc75",
          "publicURL": "/payload/galleryMedia/386_PGPS_SPA_LOUNGE-4.webp",
          "filename": "386_PGPS_SPA_LOUNGE-4.webp",
          "mimeType": "image/webp",
          "filesize": 321328,
          "width": 2250,
          "height": 1500,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-21T12:11:14.037Z",
          "updatedAt": "2025-01-21T12:11:14.037Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/386_PGPS_SPA_LOUNGE-4.webp",
          "thumbnailURL": null
        },
        "category": "Amenities",
        "id": "678f8ed76a9783f921c4748b"
      },
      {
        "content": {
          "id": "679255ad3ac89aec3d0d110f",
          "publicURL": "/payload/galleryMedia/moonlight.webp",
          "filename": "moonlight.webp",
          "mimeType": "image/webp",
          "filesize": 356318,
          "width": 2500,
          "height": 1667,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-23T14:43:57.910Z",
          "updatedAt": "2025-01-23T14:43:57.910Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/moonlight.webp",
          "thumbnailURL": null
        },
        "category": "Homes",
        "id": "679255a459adf92acc5b4a8d"
      },
      {
        "content": {
          "id": "679373383ac89aec3d0d2943",
          "publicURL": "/payload/galleryMedia/logo-1.jpg",
          "filename": "logo-1.jpg",
          "mimeType": "image/jpeg",
          "filesize": 489751,
          "width": 4094,
          "height": 4008,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-24T11:02:16.933Z",
          "updatedAt": "2025-01-29T10:11:52.408Z",
          "thumbnailURL": null,
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/logo-1.jpg"
        },
        "category": "Amenities",
        "id": "67937330f4294f909c4df853"
      },
      {
        "content": {
          "id": "6799fef13ac89aec3d0dadc5",
          "publicURL": "/payload/galleryMedia/logo.jpg",
          "filename": "logo.jpg",
          "mimeType": "image/jpeg",
          "filesize": 489751,
          "width": 4094,
          "height": 4008,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2025-01-29T10:12:01.735Z",
          "updatedAt": "2025-01-29T10:12:01.735Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/logo.jpg",
          "thumbnailURL": null
        },
        "category": "Exteriors",
        "id": "6793733af4294f909c4df854"
      },
      {
        "content": {
          "id": "679cfaad3ac89aec3d0de7b1",
          "publicURL": "/payload/galleryMedia/intro-logo.mp4",
          "filename": "intro-logo.mp4",
          "mimeType": "video/mp4",
          "filesize": 4074309,
          "createdAt": "2025-01-31T16:30:37.752Z",
          "updatedAt": "2025-01-31T16:30:37.752Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/intro-logo.mp4",
          "thumbnailURL": null
        },
        "category": "Film",
        "id": "679cf9cf149d07aad24c4510"
      }
    ]
  },
  "mapData": {
    "relationTo": "map",
    "name": "Map - Trillium",
    "feature": "googleMaps",
    "mapSettings": {
      "zoom": 16,
      "unitSystem": "IMPERIAL",
      "withDirections": true
    },
    "mapPOIS": {
      "poiSettings": {
        "poiVisibility": "scaleActive",
        "poiIcon": {
          "id": "671a2c668168a18eb3452088",
          "publicURL": "/payload/organisationMedia/logo-3.png",
          "filename": "logo-3.png",
          "mimeType": "image/png",
          "filesize": 1618,
          "width": 100,
          "height": 100,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-10-24T11:15:50.415Z",
          "updatedAt": "2024-10-24T11:15:50.415Z",
          "url": "https://luna.vmistudio.com/api/organisationMedia/file/logo-3.png",
          "thumbnailURL": null
        }
      },
      "mainMarker": {
        "name": "Trillium",
        "description": "Trillium houses",
        "iconPath": {
          "id": "67459e04a0480a03f68c4f32",
          "publicURL": "/payload/organisationMedia/trillium-poi.svg",
          "filename": "trillium-poi.svg",
          "mimeType": "image/svg+xml",
          "filesize": 910,
          "width": 100,
          "height": 100,
          "createdAt": "2024-11-26T10:08:04.038Z",
          "updatedAt": "2024-11-26T10:08:04.038Z",
          "url": "https://luna.vmistudio.com/api/organisationMedia/file/trillium-poi.svg",
          "thumbnailURL": null
        },
        "coordinates": {
          "lat": 51.52106218964508,
          "lng": -0.17181279263670524
        }
      },
      "pois": [
        {
          "name": "University College London",
          "description": "",
          "category": "Universities",
          "coordinates": {
            "lat": 51.52464261757258,
            "lng": -0.1342948647163309
          },
          "iconPath": null,
          "id": "671b6f548844e00026fe9a67"
        },
        {
          "name": "University of London",
          "description": "",
          "category": "Universities",
          "coordinates": {
            "lat": 51.52340066877794,
            "lng": -0.13087757163256974
          },
          "iconPath": {
            "id": "671a2c668168a18eb3452088",
            "publicURL": "/payload/organisationMedia/logo-3.png",
            "filename": "logo-3.png",
            "mimeType": "image/png",
            "filesize": 1618,
            "width": 100,
            "height": 100,
            "focalX": 50,
            "focalY": 50,
            "createdAt": "2024-10-24T11:15:50.415Z",
            "updatedAt": "2024-10-24T11:15:50.415Z",
            "url": "https://luna.vmistudio.com/api/organisationMedia/file/logo-3.png",
            "thumbnailURL": null
          },
          "id": "671b6f798844e00026fe9a68"
        },
        {
          "name": "University of Westminster",
          "category": "Universities",
          "coordinates": {
            "lat": 51.52237758452927,
            "lng": -0.15498962706492794
          },
          "id": "6745a5021128c70026d05c41"
        },
        {
          "name": "London Business School",
          "category": "Universities",
          "coordinates": {
            "lat": 51.52628182206884,
            "lng": -0.16078068810105828
          },
          "id": "6745a5381128c70026d05c42"
        },
        {
          "name": "Imperial College London",
          "category": "Universities",
          "coordinates": {
            "lat": 51.498908999118115,
            "lng": -0.1748198574132328
          },
          "id": "6745a54e1128c70026d05c43"
        },
        {
          "name": "King’s College London",
          "category": "Universities",
          "coordinates": {
            "lat": 51.512603773169836,
            "lng": -0.1163370724095914
          },
          "id": "6745a5701128c70026d05c44"
        },
        {
          "name": "London School of Economics",
          "category": "Universities",
          "coordinates": {
            "lat": 51.51455627695474,
            "lng": -0.11647626401662182
          },
          "id": "6745a5ab1128c70026d05c45"
        },
        {
          "name": "Tabernacle School",
          "category": "Secondary Schools",
          "coordinates": {
            "lat": 51.50768594887807,
            "lng": -0.21483149974074842
          },
          "id": "674d9826deae072033604643"
        },
        {
          "name": "Westminster School",
          "category": "Secondary Schools",
          "coordinates": {
            "lat": 51.498940866742664,
            "lng": -0.1277783511802419
          },
          "id": "674d984fdeae072033604644"
        },
        {
          "name": "Eaton Square",
          "category": "Secondary Schools",
          "coordinates": {
            "lat": 51.4929700564442,
            "lng": -0.14283406665335652
          },
          "id": "674d987fdeae072033604645"
        },
        {
          "name": "Portland Place School",
          "category": "Secondary Schools",
          "coordinates": {
            "lat": 51.52100631498087,
            "lng": -0.14493424577346237
          },
          "id": "674d989bdeae072033604646"
        },
        {
          "name": "Francis Holland School",
          "category": "Secondary Schools",
          "coordinates": {
            "lat": 51.49285970969156,
            "lng": -0.15379046667602078
          },
          "id": "674d98b2deae072033604647"
        },
        {
          "name": "Abercorn School",
          "category": "Primary Schools",
          "coordinates": {
            "lat": 51.53290327486927,
            "lng": -0.17967732857597382
          },
          "id": "674d98c9deae072033604648"
        },
        {
          "name": "St John’s Wood Pre-Preparatory",
          "category": "Primary Schools",
          "coordinates": {
            "lat": 51.5307383846794,
            "lng": -0.1680567322813868
          },
          "id": "674d98dedeae072033604649"
        },
        {
          "name": "Falkner House Boys",
          "category": "Primary Schools",
          "coordinates": {
            "lat": 51.49125237478953,
            "lng": -0.19353961693842495
          },
          "id": "674d98f1deae07203360464a"
        },
        {
          "name": "Wetherby Preparatory School",
          "category": "Primary Schools",
          "coordinates": {
            "lat": 51.51675644720059,
            "lng": -0.16089408439604677
          },
          "id": "674d9904deae07203360464b"
        },
        {
          "name": "Hill House School",
          "category": "Primary Schools",
          "coordinates": {
            "lat": 51.49762867300951,
            "lng": -0.1602370169381853
          },
          "id": "674d9918deae07203360464c"
        }
      ]
    },
    "mapStyling": {
      "styleKey": "default",
      "style": [],
      "customColors": {
        "landscapeColor": "#f0e9cb",
        "waterColor": "#f0e9cb",
        "parksColor": "#eae7d3",
        "arterialColor": "#ffffff",
        "localColor": "#ffffff",
        "labelsColor": "#eae7d3"
      }
    },
    "categories": [
      "Universities",
      "Secondary Schools",
      "Primary Schools",
      "Green Spaces",
      "Cultural",
      "Dining",
      "Shopping"
    ]
  },
  "residencesData": {
    "relationTo": "residences",
    "feature": "residencesType2",
    "categories": [
      "Floorplan",
      "View",
      "Specifications"
    ],
    "name": "Residences - Trillium"
  },
  "orbitData": {
    "relationTo": "orbits",
    "name": "Orbits - Trillium",
    "feature": "orbit3d",
    "cameraPoints": [],
    "touchPoints": []
  },
  "splashData": {
    "relationTo": "splash",
    "name": "Splash - Trillium",
    "heroCopy": "Residences",
    "heroCopyFont": "primaryFont",
    "heroCopyColour": "primary",
    "heroCopyStyle": "normal",
    "buttonBgColour": "accent",
    "buttonWidth": 10,
    "buttonBgLink": "residences",
    "logo": "lightColourLogo",
    "logoWidth": 24.25,
    "splashBg": "image/video",
    "splashBgMediaOpacity": 1,
    "splashBgMedia": {
      "id": "671bb09fee5ee5f3d8e8982c",
      "publicURL": "/payload/splashMedia/trilium.mp4",
      "filename": "trilium.mp4",
      "mimeType": "video/mp4",
      "filesize": 40873551,
      "createdAt": "2024-10-25T14:52:15.600Z",
      "updatedAt": "2024-10-25T14:52:15.600Z",
      "url": "https://luna.vmistudio.com/api/splashMedia/file/trilium.mp4",
      "thumbnailURL": null
    }
  },
  "availabilityData": {
    "relationTo": "unitAvailability",
    "name": "Unit Availability - Trillium",
    "data": [
      {
        "unitName": "101",
        "price": 20,
        "floor": 1,
        "beds": 1,
        "baths": 1,
        "unitType": "1A",
        "aspect": "N",
        "viewID": "A-B-3m",
        "status": "Available",
        "id": "671b73a78844e00026feb4f9"
      },
      {
        "unitName": "102",
        "price": 20,
        "floor": 1,
        "beds": 1,
        "baths": 1,
        "unitType": "1A",
        "aspect": "N",
        "viewID": "A-B-3m",
        "status": "Available",
        "id": "671b73f33f0c79127e0eb65a"
      },
      {
        "unitName": "103",
        "price": 40,
        "floor": 2,
        "beds": 2,
        "baths": 2,
        "unitType": "2A",
        "aspect": "E",
        "viewID": "C-D-12m",
        "status": "Available",
        "id": "671b73bd8844e00026feb4fa"
      },
      {
        "unitName": "104",
        "price": 40,
        "floor": 2,
        "beds": 2,
        "baths": 2,
        "unitType": "2A",
        "aspect": "E",
        "viewID": "C-D-12m",
        "status": "Available",
        "id": "671b73fb3f0c79127e0eb65d"
      }
    ]
  },
  "typeData": {
    "relationTo": "unitTypes",
    "name": "Unit Types - Trillium",
    "unitTypes": [
      {
        "name": "1A",
        "beds": 1,
        "baths": 1,
        "floorplan": "673c899ca0480a03f68af80e",
        "copy": "A nice apartment",
        "id": "671b70398844e00026fea98a"
      },
      {
        "name": "2A",
        "beds": 2,
        "baths": 2,
        "floorplan": "673c89a4a0480a03f68af82a",
        "copy": "A very nice apartment",
        "id": "671b704b8844e00026fea98b"
      }
    ]
  },
  "viewsData": {
    "relationTo": "unitViews",
    "name": "Unit Views - Trillium",
    "viewMedia": [
      {
        "image": {
          "id": "671910b7535ac37b8d5341c0",
          "publicURL": "/payload/viewMedia/A-3m.webp",
          "filename": "A-3m.webp",
          "mimeType": "image/webp",
          "filesize": 869212,
          "width": 5000,
          "height": 1990,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-10-23T15:05:27.577Z",
          "updatedAt": "2024-10-23T15:05:27.577Z",
          "url": "https://luna.vmistudio.com/api/viewMedia/file/A-3m.webp",
          "thumbnailURL": null
        },
        "id": "671b74798844e00026feb574"
      },
      {
        "image": {
          "id": "671910c1535ac37b8d5341e2",
          "publicURL": "/payload/viewMedia/B-3m.webp",
          "filename": "B-3m.webp",
          "mimeType": "image/webp",
          "filesize": 1940010,
          "width": 6778,
          "height": 2357,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-10-23T15:05:37.338Z",
          "updatedAt": "2024-10-23T15:05:37.338Z",
          "url": "https://luna.vmistudio.com/api/viewMedia/file/B-3m.webp",
          "thumbnailURL": null
        },
        "id": "671b747c8844e00026feb575"
      },
      {
        "image": {
          "id": "67191095535ac37b8d534172",
          "publicURL": "/payload/viewMedia/C-12m.webp",
          "filename": "C-12m.webp",
          "mimeType": "image/webp",
          "filesize": 869212,
          "width": 5000,
          "height": 1990,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-10-23T15:04:53.249Z",
          "updatedAt": "2024-10-23T15:04:53.249Z",
          "url": "https://luna.vmistudio.com/api/viewMedia/file/C-12m.webp",
          "thumbnailURL": null
        },
        "id": "671b74818844e00026feb576"
      },
      {
        "image": {
          "id": "6719109e535ac37b8d534193",
          "publicURL": "/payload/viewMedia/D-12m.webp",
          "filename": "D-12m.webp",
          "mimeType": "image/webp",
          "filesize": 1940010,
          "width": 6778,
          "height": 2357,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-10-23T15:05:02.855Z",
          "updatedAt": "2024-10-23T15:05:02.855Z",
          "url": "https://luna.vmistudio.com/api/viewMedia/file/D-12m.webp",
          "thumbnailURL": null
        },
        "id": "671b74858844e00026feb577"
      }
    ]
  },
  "detailsData": {
    "relationTo": "unitDetails",
    "name": "Unit Details - Trillium"
  },
  "navRoutes": [
    {
      "path": "orbits",
      "feature": "orbit3d",
      "layout": "sidebar",
      "label": "Trillium",
      "include": "true"
    },
    {
      "path": "residences",
      "feature": "residencesType2",
      "layout": "sidebar",
      "label": "Floorplans",
      "include": "true"
    },
    {
      "path": "info1",
      "feature": "info1",
      "layout": "sidebar",
      "label": "Amenities",
      "include": "true"
    },
    {
      "path": "map",
      "feature": "googleMaps",
      "layout": "sidebar",
      "label": "Local Area",
      "include": "true"
    },
    {
      "path": "gallery",
      "feature": "masonrygallery",
      "layout": "sidebar",
      "label": "Gallery",
      "include": "true"
    },
    {
      "path": "favourites",
      "feature": "favourites",
      "layout": "sidebar",
      "label": "Favourites",
      "include": "true"
    },
    {
      "path": "explorer",
      "feature": null,
      "layout": "sidebar",
      "label": "Explorer",
      "include": "false"
    },
    {
      "path": "sharedOwnership",
      "feature": "sharedOwnership",
      "layout": "sidebar",
      "label": "Shared Ownership",
      "include": "false"
    },
    {
      "path": "about",
      "feature": "about",
      "layout": "sidebar",
      "label": "About Page",
      "include": "false"
    },
    {
      "path": "development",
      "feature": "development",
      "layout": "sidebar",
      "label": "Media",
      "include": "true"
    }
  ],
  "allRoutes": [
    {
      "path": "/",
      "feature": "sidebar-splash",
      "layout": "sidebar",
      "include": "true"
    },
    {
      "path": "orbits",
      "feature": "orbit3d",
      "layout": "sidebar",
      "label": "Trillium",
      "include": "true"
    },
    {
      "path": "residences",
      "feature": "residencesType2",
      "layout": "sidebar",
      "label": "Floorplans",
      "include": "true"
    },
    {
      "path": "info1",
      "feature": "info1",
      "layout": "sidebar",
      "label": "Amenities",
      "include": "true"
    },
    {
      "path": "map",
      "feature": "googleMaps",
      "layout": "sidebar",
      "label": "Local Area",
      "include": "true"
    },
    {
      "path": "gallery",
      "feature": "masonrygallery",
      "layout": "sidebar",
      "label": "Gallery",
      "include": "true"
    },
    {
      "path": "favourites",
      "feature": "favourites",
      "layout": "sidebar",
      "label": "Favourites",
      "include": "true"
    },
    {
      "path": "explorer",
      "feature": null,
      "layout": "sidebar",
      "label": "Explorer",
      "include": "false"
    },
    {
      "path": "sharedOwnership",
      "feature": "sharedOwnership",
      "layout": "sidebar",
      "label": "Shared Ownership",
      "include": "false"
    },
    {
      "path": "about",
      "feature": "about",
      "layout": "sidebar",
      "label": "About Page",
      "include": "false"
    },
    {
      "path": "development",
      "feature": "development",
      "layout": "sidebar",
      "label": "Media",
      "include": "true"
    }
  ]
};
  